import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('p', {
    staticClass: "card-description my-0 py-0"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.map.overlayWizard.coordinateText1')))]), _c('core-address-picker', {
    staticStyle: {
      "height": "80px"
    },
    attrs: {
      "mapView": false,
      "addressObject": _vm.addressObject
    },
    on: {
      "address-selected": _vm.addressSelected
    }
  }), _c('div', {
    staticClass: "mb-1",
    staticStyle: {
      "display": "flex",
      "flex-direction": "row",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('p', {
    staticClass: "card-description my-0 py-0",
    staticStyle: {
      "display": "flex"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.map.overlayWizard.coordinateText2')) + "\n    ")])]), _c('CoreMapboxMglMap', {
    ref: "twinMap",
    staticClass: "twinMap regularMap",
    attrs: {
      "attributionControl": false
    },
    on: {
      "load": _vm.onMapLoaded,
      "click": _vm.onMapClicked
    }
  }, [_vm.anchor1 ? _c('MglMarker', {
    attrs: {
      "coordinates": _vm.anchor1,
      "color": 'red',
      "draggable": "",
      "anchor": "bottom"
    },
    on: {
      "dragend": _vm.onMarker1Dragged
    }
  }, [_c('span', {
    attrs: {
      "slot": "marker"
    },
    slot: "marker"
  }, [_c(VIcon, {
    staticClass: "markerPin",
    attrs: {
      "color": "red",
      "size": "25"
    }
  }, [_vm._v("fal fa-map-pin")])], 1)]) : _vm._e(), _vm.anchor2 ? _c('MglMarker', {
    attrs: {
      "coordinates": _vm.anchor2,
      "color": 'blue',
      "draggable": "",
      "anchor": "bottom"
    },
    on: {
      "dragend": _vm.onMarker2Dragged
    }
  }, [_c('span', {
    attrs: {
      "slot": "marker"
    },
    slot: "marker"
  }, [_c(VIcon, {
    staticClass: "markerPin",
    attrs: {
      "color": "blue",
      "size": "25"
    }
  }, [_vm._v("fal fa-map-pin")])], 1)]) : _vm._e(), _c('MglNavigationControl', {
    attrs: {
      "position": "bottom-right"
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };